module.exports = __webpack_public_path__ + "img/IMG_9674-8.5e65a34d.png";